module.exports = __webpack_public_path__ + "img/abalogix_transparent.2c88ca1b.png";